module.exports = __webpack_public_path__ + "static/media/landscape.54409410.svg";